import { createFileTree, createRevisions, returnXML } from './helper.js';

export const parserMap = {
  FILE_STRUCTURE: createFileTree,
  REVISION: createRevisions,
  XML: returnXML,
};

export function dvsRestPoint(key, siteId, category, assetId, revNum, page) {
  switch (key) {
    case 'FILE_STRUCTURE':
      return `/dvs/rest/configs/${siteId}/`;
    case 'REVISION':
      return `/dvs/rest/configs/${siteId}/${category}/${assetId}/log?page=${page}`;
    case 'XML':
      return `/dvs/rest/configs/${siteId}/${category}/${assetId}/revision/${revNum}`;
    default:
      return '/';
  }
}

export function urlPath(key, navigate, siteId, folder, file, sourceRev, targetRev) {
  switch (key) {
    case 'FILE_STRUCTURE':
      navigate(`/${siteId}/`);
      break;
    case 'REVISION':
      navigate(`/${siteId}/${folder}/${file}/`);
      break;
    case 'XML':
      navigate(`/${siteId}/${folder}/${file}/${sourceRev}/${targetRev}/`);
      break;
    default:
      return '/';
  }
}
